// Thin wrappers over /v1/auth/* + /v1/me (proxied by the go-pim admin API BFF).
//
// Audience is `panel-api` by default (VITE_PIM_AUDIENCE) — this reuses the
// existing panel JWKS + RBAC that auth-service already issues, so an operator
// who logs into another panel is already minted for go-pim. The SPA only sends
// the audience as a label; the server enforces.
//
// Passkeys / WebAuthn were dropped from go-pim-ui to shrink scope; the BFF's
// /v1/auth/webauthn/* surface is a later backend step.
import { apiClient } from "./client";
import type { Me } from "@/store/auth";

const audience = import.meta.env.VITE_PIM_AUDIENCE || "panel-api";

interface AccessTokenResponse {
  access_token: string;
}

export async function requestOtp(email: string): Promise<void> {
  await apiClient.post("/v1/auth/otp/request", { email, audience });
}

export async function verifyOtp(
  email: string,
  code: string,
): Promise<AccessTokenResponse> {
  const resp = await apiClient.post<AccessTokenResponse>(
    "/v1/auth/otp/verify",
    { email, audience, code },
  );
  return resp.data;
}

export async function refresh(): Promise<AccessTokenResponse> {
  const resp = await apiClient.post<AccessTokenResponse>("/v1/auth/refresh", {});
  return resp.data;
}

export async function logout(): Promise<void> {
  await apiClient.post("/v1/auth/logout");
}

export async function getMe(): Promise<Me> {
  const resp = await apiClient.get<Me>("/v1/me");
  return resp.data;
}
